function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  var customBody = document.querySelector('#MainContent');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// class QuantityInput extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input');
//     this.changeEvent = new Event('change', { bubbles: true });
//     this.input.addEventListener('change', this.onInputChange.bind(this));
//     this.querySelectorAll('button').forEach((button) =>
//       button.addEventListener('click', this.onButtonClick.bind(this))
//     );
//   }

//   quantityUpdateUnsubscriber = undefined;

//   connectedCallback() {
//     this.validateQtyRules();
//     this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
//   }

//   disconnectedCallback() {
//     if (this.quantityUpdateUnsubscriber) {
//       this.quantityUpdateUnsubscriber();
//     }
//   }

//   onInputChange(event) {
//     this.validateQtyRules();
//   }

//   onButtonClick(event) {
    
//     event.preventDefault();
//     const previousValue = this.input.value;

//     event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
//     if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
//     if (qs(".variant-inventory")) {
//       event.preventDefault();
//       event.stopPropagation();
//       let currVarId = window.variantId;
//       let stoke = qs('.variant-inventory[data-variant-id="' + currVarId + '"]').textContent;
//       let val = parseInt(qs(".product-form__buttons quantity-input .quantity__input").value);
//       if (stoke <= val) {
//         qs(".product-form__buttons quantity-input .quantity__input").value = stoke;
//         qs(".product-form__buttons .quantity__button.plus").classList.add("not_Added_atc");
//       }
//       else {
//         qs(".product-form__buttons .quantity__button.plus").classList.remove("not_Added_atc");
//       }
//     }
//   }

//   validateQtyRules() {
//     const value = parseInt(this.input.value);
//     if (this.input.min) {
//       const min = parseInt(this.input.min);
//       const buttonMinus = this.querySelector(".quantity__button[name='minus']");
//       buttonMinus.classList.toggle('disabled', value <= min);
//     }
//     if (this.input.max) {
//       const max = parseInt(this.input.max);
//       const buttonPlus = this.querySelector(".quantity__button[name='plus']");
//       buttonPlus.classList.toggle('disabled', value >= max);
//     }
//   }
// }


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    if (!this.input) return;
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    if (!this.input) return;
    this.validateQtyRules();
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this)
      );
    }
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();

    if (!this.input) return;

    const previousValue = this.input.value;
    const isPlus = event.currentTarget.name === 'plus';

    isPlus ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    // 🔹 Inventory limit logic – scoped per card/product
    const card =
      this.closest('.product-card-wrapper') ||
      this.closest('.card-wrapper') ||
      this.closest('.product-form, .product');

    if (!card) return;

    // Get current variant id from the form inside this card
    const form = this.closest('form');
    const idInput = form && form.querySelector('input[name="id"]');
    if (!idInput) return;

    const currVarId = idInput.value;
    if (!currVarId) return;

    const stockNode = card.querySelector(
      `.variant-inventory[data-variant-id="${currVarId}"]`
    );
    if (!stockNode) return;
    if (stockNode.dataset.stockLimited !== 'true') return;

    const stock = parseInt(stockNode.textContent, 10);
    if (isNaN(stock)) return;

    let val = parseInt(this.input.value, 10) || 0;

    const plusButton = this.querySelector(".quantity__button[name='plus']");

    if (val >= stock) {
      this.input.value = stock;
      if (plusButton) plusButton.classList.add('not_Added_atc');
      // keep value in sync after clamp
      this.input.dispatchEvent(this.changeEvent);
    } else {
      if (plusButton) plusButton.classList.remove('not_Added_atc');
    }
  }

  validateQtyRules() {
    if (!this.input) return;

    const value = parseInt(this.input.value, 10) || 0;

    const minAttr = this.input.dataset.min || this.input.min;
    const min = minAttr ? parseInt(minAttr, 10) : null;

    const cartQty = this.input.dataset.cartQuantity
      ? parseInt(this.input.dataset.cartQuantity, 10)
      : 0;

    const maxAttr = this.input.dataset.max || this.input.max;
    const max = maxAttr ? parseInt(maxAttr, 10) : null;

    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".quantity__button[name='plus']");

    // 🔹 Disable minus at min
    if (buttonMinus && min !== null) {
      buttonMinus.classList.toggle('disabled', value <= min);
    }

    // 🔹 Disable plus when (current value + cart_qty) >= max
    if (buttonPlus && max !== null) {
      const reachedLimit = value + cartQty >= max;
      buttonPlus.classList.toggle('disabled', reachedLimit);
    }
  }

}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        qs(".announcement-bar-section").classList.add('hide');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    // qs(".footer-fix-bottom").classList.add("hide");
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      qs(".announcement-bar-section").classList.add('hide');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    qs(".announcement-bar-section").classList.remove('hide');
    // qs(".footer-fix-bottom").classList.remove("hide");
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    qs(".announcement-bar-section").classList.add('hide');
    // qs('.fixed-bottom .realtive_li').classList.add('active');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header && this.header.classList.remove('menu-open');
    // qs('.fixed-bottom .realtive_li').classList.remove('active');
    qs(".announcement-bar-section").classList.remove('hide');
    window.removeEventListener('resize', this.onResize);
  }
  

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }
  convertToPositive(value) {
    return Math.abs(value);
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.slidesPerPage = this.convertToPositive(this.slidesPerPage)
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-component', SliderComponent);


class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    if (!this.sliderFirstItemNode) return;
    const index = this.sliderControlLinksArray.indexOf(event.currentTarget);
    const direction = this.sliderItemOffset < 0 ? -1 : 1;
    const slideScrollPosition =
      this.slider.scrollLeft +
      direction * this.sliderFirstItemNode.clientWidth * (index + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    console.log("This is VariantSelects constructor");
    
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);

    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    function soldOutRandom() {
      const el = document.querySelector('.bought-items .last-count-no');
      if (!el) return;
      const count = randomInt(window.minCount, window.maxCount);
      el.textContent = `${count}`;
    }
    soldOutRandom();
    console.log("This is VariantSelects onVariantChange function");
    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateSelectedOptionLabels() {
    if (!this.currentVariant) return;

    const optionValues = this.currentVariant.options || [
      this.currentVariant.option1,
      this.currentVariant.option2,
      this.currentVariant.option3,
    ].filter((option) => option !== undefined && option !== null);

    this.querySelectorAll('.product-form__input').forEach((optionWrapper, index) => {
      const optionValue = optionValues[index];
      if (optionValue === undefined) return;

      const selectedLabel = optionWrapper.querySelector('[id^="selected-"]');
      if (selectedLabel) {
        const leadingWhitespace = selectedLabel.textContent.match(/^\s*/) ? selectedLabel.textContent.match(/^\s*/)[0] : '';
        selectedLabel.textContent = `${leadingWhitespace}${optionValue}`;
      }

      const selectedSwatchValue = optionWrapper.querySelector('[data-selected-swatch-value]');
      if (selectedSwatchValue) selectedSwatchValue.textContent = optionValue;
    });
  }


  
updateMedia() {
  //stopAutoScrollSlider();
  if (!this.currentVariant || !this.currentVariant.featured_media) return;
  const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
  const slider = document.querySelector(`#Slider-Gallery-${this.dataset.section}`);
  const targetSlide = slider.querySelector(`.product__media-item[data-media-id="${mediaId}"]`);

  if (!targetSlide || !slider) return;

  // Remove active class from all slides
  slider.querySelectorAll('.product__media-item').forEach(item => {
    item.classList.remove('is-active');
  });

  // Add active class to the target slide
  targetSlide.classList.add('is-active');

  // Scroll into view smoothly
  slider.scrollTo({
    left: targetSlide.offsetLeft,
    behavior: 'smooth'
  });
 // startAutoScrollSlider('{{ section.id }}', 3000);
}



  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
    console.log("This is VariantSelects updateVariantStatuses function");
    
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    const addAvailabiltyClass = document.querySelector('.product-form__buttons');
    
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      addAvailabiltyClass.classList.remove('notify-me-btn-show');
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      addAvailabiltyClass.classList.add('notify-me-btn-show');
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const currentSectionId = this.dataset.section;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : currentSectionId;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const getSourceElement = (prefix) => html.getElementById(`${prefix}-${sectionId}`);
        const getDestinationElement = (prefix) => document.getElementById(`${prefix}-${currentSectionId}`);

        const destination = getDestinationElement('price');
        const source = getSourceElement('price');
        const skuSource = getSourceElement('Sku');
        const skuDestination = getDestinationElement('Sku');
        const inventorySource = getSourceElement('Inventory');
        const inventoryDestination = getDestinationElement('Inventory');
        const volumePricingSource = getSourceElement('Volume');
        const pricePerItemDestination = getDestinationElement('Price-Per-Item');
        const pricePerItemSource = getSourceElement('Price-Per-Item');
        const volumePricingDestination = getDestinationElement('Volume');
        const qtyRules = getDestinationElement('Quantity-Rules');
        const volumeNote = getDestinationElement('Volume-Note');

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = getDestinationElement('price');

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');
        this.updateSelectedOptionLabels();
        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut

        );
        if (qs(".variant-inventory")) {
          const currVarId = this.currentVariant.id;
          window.variantId = this.currentVariant.id;
          const stockNode = qs('.variant-inventory[data-variant-id="' + currVarId + '"]');
          if (!stockNode) return;
          const stoke = stockNode.textContent;
          const stockLimited = stockNode.dataset.stockLimited === 'true';
          if (!stockLimited || stoke > 0) {
            // qs(".product-form .item-count-info").classList.remove("hide");
            //qs(".product-form .item-count-info").textContent = `Last ${stoke} items left!`;
            qs(".product-form__buttons quantity-input .quantity__input").value = '1';
            qs(".product-form__buttons .quantity__button.plus").classList.remove("not_Added_atc");
          }
          else {
            qs(".product-form__buttons quantity-input .quantity__input").value = stoke;
            //qs(".product-form .item-count-info") && qs(".product-form .item-count-info").classList.add("hide");
            qs(".product-form__buttons .quantity__button.plus").classList.add("not_Added_atc");
          }
        }
        if (addButtonUpdated.hasAttribute('disabled')) {
          // qs(".product-form .item-count-info") && qs(".product-form .item-count-info").classList.add("hide");
          qsa(".out-product").forEach((el) => {
            el.classList.add("hide");
          });
          qs(".check-availability").classList.remove("hide");
          qs(".product-form__buttons quantity-input .quantity__input").value = '0';
        }
        else {
          qsa(".out-product").forEach((el) => {
            el.classList.add("hide");
          });  
          qs(".product-form__buttons quantity-input .quantity__input").value = '1';
        }


        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const hasQuote = productForm.dataset.hasQuote === 'true';
    const customAddToCartText = productForm.dataset.customAddToCartText;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (hasQuote) {
        addButtonText.textContent = "Download quotation at checkout";
      } else if (customAddToCartText) {
        addButtonText.textContent = customAddToCartText;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (qs('.pre-order-product')) {
        addButtonText.textContent = "Pre-order"
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// Desktop Mega menu

// document.addEventListener("DOMContentLoaded", function () {
//   const mainHeaders = document.querySelectorAll('.main-header');
//   const childMenus = document.querySelectorAll('.normal-list-li');
//   var newBody = document.querySelector('body');
//   let activeSubMenu = null; // Variable to store the currently active submenu

//   const grandchildMenus = document.querySelectorAll('.grandchild-links');

//   function closeAllMenus() { 
//     const subMenus = document.querySelectorAll('.header__submenu');
//     subMenus.forEach(subMenu => {
//       if (subMenu.closest('.normal-list-li') !== document.querySelector('.normal-list-li:first-child')) {
//         subMenu.classList.remove('active');
//       }
//     });

//     const grandchildMenus = document.querySelectorAll('.grandchild-links');
//     grandchildMenus.forEach(menu => {
//       newBody.classList.remove('menu-active');
//       //  mainHeaders.classList.remove('active');
//       if (menu.closest('.normal-list-li') !== document.querySelector('.normal-list-li:first-child')) {
//         menu.classList.remove('active');
//       }
//     });
//     // document.querySelector('#HeaderDrawer-categories-brew').classList.remove('active');
//   }

//   // function handleMouseOver(event) {  
//   //   const childMenu = event.currentTarget;
//   //   const grandchildMenu = childMenu.nextElementSibling;
//   //   if (grandchildMenu) {
//   //     // Close the previously active submenu
//   //     if (activeSubMenu) {        
//   //       activeSubMenu.classList.remove('active');
//   //     }
//   //     // Show the current grandchild menu      
//   //     grandchildMenu.classList.add('active');
//   //     // Update the activeSubMenu variable
//   //     activeSubMenu = grandchildMenu;
//   //   }
//   // }  

//   mainHeaders.forEach(header => {
//     header.addEventListener('click', function (event) {
//       event.stopPropagation();
//       document.querySelectorAll('.main-header').forEach(el => {
//         el.classList.remove('active');
//       });

//       header.classList.add('active');
//       closeAllMenus();
//       const subMenu = this.nextElementSibling;
//       if (subMenu) {
//         newBody.classList.add('menu-active');
//         subMenu.classList.add('active');
//       }
//     });
//   });

//   // childMenus.forEach(menu => {
//   //   menu.addEventListener('mouseover', handleMouseOver);
//   // });

//   // Select all list items
//   const listItems = document.querySelectorAll(".normal-list-li");

//   listItems.forEach(item => {
//     item.addEventListener("mouseover", function () {
//       listItems.forEach(i => {
//         i.classList.remove("active");
//         const childItem = i.querySelector('.header__menu-item');
//         const grandchildLinks = i.querySelector('.grandchild-links');
//         if (childItem) {
//           childItem.classList.remove("active");
//         }
//         if (grandchildLinks) {
//           grandchildLinks.classList.remove("active");
//         }
//       });
//       // Add the active class to the hovered list item and its child elements
//       this.classList.add("active");
//       const childItem = this.querySelector('.header__menu-item');
//       const grandchildLinks = this.querySelector('.grandchild-links');
//       if (childItem) {
//         childItem.classList.add("active");
//       }
//       if (grandchildLinks) {
//         grandchildLinks.classList.add("active");
//       }
//     });
//   });

//   // Click event listener on body to close all menus
//   document.body.addEventListener('click', function () {
//     closeAllMenus();
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  const mainHeaders = document.querySelectorAll('.main-header');
  const listItems = document.querySelectorAll(".normal-list-li");
  const body = document.querySelector('body');

  function closeAllMenus() {
    document.querySelectorAll('.main-header').forEach(h => h.classList.remove('active'));
    document.querySelectorAll('.header__submenu').forEach(m => m.classList.remove('active'));
    document.querySelectorAll('.grandchild-links').forEach(m => m.classList.remove('active'));
    document.querySelectorAll('.normal-list-li').forEach(li => li.classList.remove('active'));
    body.classList.remove('menu-active');
  }

  // -------------------------------
  // 1️⃣ Main header click → open submenu
  // -------------------------------
  mainHeaders.forEach(header => {
    header.addEventListener("click", function (e) {
      e.stopPropagation();
      closeAllMenus();

      this.classList.add('active');
      const subMenu = this.nextElementSibling;

      if (subMenu) {
        body.classList.add('menu-active');
        subMenu.classList.add('active');
      }
    });
  });

  // -------------------------------
  // 2️⃣ Child menu item click → open grandchild menu
  // -------------------------------
  listItems.forEach(item => {
    item.addEventListener("click", function (e) {
      e.stopPropagation();

      // Close siblings only
      const parentList = this.parentElement.querySelectorAll('.normal-list-li');
      parentList.forEach(sibling => {
        if (sibling !== this) {
          sibling.classList.remove("active");
          const submenu = sibling.querySelector('.grandchild-links');
          if (submenu) submenu.classList.remove("active");
        }
      });

      // Toggle current item
      this.classList.toggle("active");

      const grandchild = this.querySelector('.grandchild-links');
      if (grandchild) {
        grandchild.classList.toggle("active");
      }
    });
  });

  // -------------------------------
  // 3️⃣ Click outside to close all
  // -------------------------------
  document.body.addEventListener("click", function () {
    closeAllMenus();
  });
});





// Mobile menu 

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.mb-child-menu').forEach(function (element) {
    element.addEventListener('click', function () {
      if(document.querySelector('#HeaderDrawer-categories-brews')){
        document.querySelector('#HeaderDrawer-categories-brews').classList.remove('active');
      }
    
      document.querySelectorAll('.mb-grandchild-menu.grandchild-active').forEach(function (activeElement) {
        // qs(".menu-drawer__menu-item.mb-child-menu").classList.remove('himanshu-text');
        activeElement.classList.remove('grandchild-active');
       
      });

      // Add 'active' class to the next sibling
      if (this.nextElementSibling && this.nextElementSibling.classList.contains('mb-grandchild-menu')) {
        this.nextElementSibling.classList.add('grandchild-active');
        // qs(".menu-drawer__menu-item.mb-child-menu").classList.add('himanshu-text');

      }
      else {

      }
    });
  });
  const firstNormalListLi = document.querySelector('.menu-drawer__menu.double-menu li:first-child .menu-drawer__submenu');
  firstNormalListLi.classList.add('grandchild-active');
  // document.querySelector('#HeaderMenu-MenuList-1 .normal-list .normal-list-li:first-child').classList.add('active');
  // qs('#HeaderDrawer-categories').addEventListener("click", () => {
  //   if(document.querySelector('#HeaderDrawer-categories-brews')){
  //     document.querySelector('#HeaderDrawer-categories-brews').classList.add('active');
  //   }
  // });
});

// Spare Part Products Added
document.addEventListener('DOMContentLoaded', function () {
  const sparepartBtn = document.querySelector('.sparepart-btn');
  const sparePartATC = document.querySelector('#SparePartAddToCart');
  const sparePartContent = document.querySelector('.spare-part-content');
  const closeBtn = document.getElementById('close');

  // Function to open the drawer
  function openDrawer() {
    sparePartContent.classList.add('spare-part-active');
    document.body.classList.add('drawer-active');
  }

  // Function to close the drawer
  function closeDrawer() {
    sparePartContent.classList.remove('spare-part-active');
    document.body.classList.remove('drawer-active');
  }

  // Event listener to open the drawer
  if (sparepartBtn !== null) {
    sparepartBtn.addEventListener('click', openDrawer);
  }
  // Event listener to close the drawer
  if (closeBtn !== null) {
    closeBtn.addEventListener('click', closeDrawer);
  }
  if (sparePartATC) {
    sparePartATC.addEventListener('click', function () {
      setTimeout(() => {
        closeDrawer();
      }, 1000);
    });
  }


  // Event listener to close the drawer when clicking outside
  document.addEventListener('click', function (event) {
    if (sparePartContent) {
      if (!sparePartContent.contains(event.target) && !sparepartBtn.contains(event.target)) {
        closeDrawer();
      }
    }
  });

});


// Sticky collection page heading filters
const facetFiltersForm = document.querySelector('facet-filters-form');
const facetsVertical = document.querySelector('.facets-vertical');

const observerOptions = {
    root: null, // Use the viewport as the container
    rootMargin: '0px',
    threshold: 0 // Trigger as soon as even one pixel is visible
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting && window.innerWidth >= 768) {
            facetFiltersForm.classList.add('sticky');
        } else {
            facetFiltersForm.classList.remove('sticky');
        }
    });
}, observerOptions);

if (facetsVertical instanceof Element) {
  observer.observe(facetsVertical);
} else {
  
}

var closeFormBtn = document.querySelector('.close-form');
if (closeFormBtn) {
  function closeForm(){
    const closeFormBtn = document.querySelector('.close-form');
    closeFormBtn.addEventListener('click', function() {      
        location.reload();
    });
  }
  closeForm();
  
}
document.addEventListener('click', function(event) {
  const popup = document.querySelector('.popup');
  
  if (!popup.contains(event.target)) {
      popup.style.display = 'none';
  }
});

// let autoScrollInterval = null; // global (or scoped higher than your function)

// function startAutoScrollSlider(sectionId, interval = 3000) {
//   const slider = document.querySelector(`.product__media-list.contains-media`);
//   if (!slider) return;

//   const slides = slider.querySelectorAll('.product__media-item');
//   if (!slides.length) return;

//   // Prevent multiple intervals
//   stopAutoScrollSlider();

//   autoScrollInterval = setInterval(() => {
//     let activeSlide = slider.querySelector('.is-active');
//     let currentIndex = activeSlide 
//       ? Array.from(slides).indexOf(activeSlide) + 1
//       : 0;

//     if (currentIndex >= slides.length) currentIndex = 0;

//     // remove active class
//     if (activeSlide) activeSlide.classList.remove('is-active');

//     // add active class to new slide
//     slides[currentIndex].classList.add('is-active');

//     // smooth scroll
//     slider.scrollTo({
//       left: slides[currentIndex].offsetLeft,
//       behavior: 'smooth'
//     });
//   }, interval);
// }

// function stopAutoScrollSlider() {
//   if (autoScrollInterval) {
//     clearInterval(autoScrollInterval);
//     autoScrollInterval = null;
//   }
// }


// // Example: Run this after DOM is ready
// document.addEventListener('DOMContentLoaded', () => {
//   startAutoScrollSlider('{{ section.id }}', 3000); // 3 sec per slide
// });





